const APPCONST={}

APPCONST.app_url='preseedherbicide';
APPCONST.server_url=(window.location.hostname!=='localhost')?'':'http://localhost:3001';
APPCONST.vr_url=`${APPCONST.server_url}/${APPCONST.app_url}/static/`;
APPCONST.googleTagManagerCode = 'GTM-KT2BX73';
APPCONST.googleAnalyticsCode = 'UA-172378819-1';
APPCONST.contestOver = (new Date('September 30, 2020 24:00') < new Date());

export default APPCONST;